export default {
	'notifications.error': 'The following errors were found with the source file and mapping:'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/en-us/notifications.js